/** Strings of `/alerts` and the red Grafana banner: `alertsEn` is the source, `alertsCs` must have the same keys. */
export const alertsEn = {
  alerts: {
    title: "Alerts",
    liveFromGrafana: "Live from Grafana",
    updated: " · updated ",
    refresh: "Refresh",
    grafana: "Grafana",
    loading: "Loading…",
    endpointError:
      "Couldn't reach Hub's alert endpoint: {{error}}. Showing the last answer, if any.",
    serverDown: "{{url}} didn't answer ({{error}})",
    staleFrom: " — its alerts below are from ",
    alertsUnknown: " — its alerts are unknown.",
    noGrafana:
      "No Grafana is connected. Hub reads alerts from the Grafana behind log triage — set <code>GRAFANA_DISCOVER_URL</code> or add a log source.",
    sections: {
      firing: "Firing",
      firingHint: "The condition holds right now and Grafana has notified.",
      pending: "Pending",
      pendingHint: "The condition holds, but not yet for as long as the rule waits before firing.",
      error: "Broken rules",
      errorHint: "Grafana couldn't evaluate these — they can't warn about anything until fixed.",
    },
    tiles: {
      firing: "Firing",
      pending: "Pending",
      broken: "Broken rules",
      watched: "Rules watched",
    },
    firingHero_one: "{{count}} alert is firing",
    firingHero_other: "{{count}} alerts are firing",
    firingHero_few: "{{count}} alerts are firing",
    criticalCount: "{{count}} critical · ",
    allClear: "All clear",
    nothingFiring: "Nothing is firing across {{count}} rules.",
    since: "since ",
    ruleInGrafana: "Rule in Grafana",
    fixInHub: "Fix in Hub",
    dashboard: "Dashboard",
    project: {
      heading: "Alerts of a project",
      choose: "Choose a project",
      loading: "Loading…",
      settings: "Open the project's settings",
      folder: "Grafana folder: {{folder}}",
      fromUid: "assigned by uid in the settings",
      byName: "found by name",
    },
    allRules: "All rules ({{count}})",
    targets: "{{count}} targets",
    banner: {
      firing_one: "{{count}} alert firing",
      firing_other: "{{count}} alerts firing",
      firing_few: "{{count}} alerts firing",
      show: "Show →",
    },
  },
};
export const alertsCs: typeof alertsEn = {
  alerts: {
    title: "Alerty",
    liveFromGrafana: "Živě z Grafany",
    updated: " · aktualizováno ",
    refresh: "Obnovit",
    grafana: "Grafana",
    loading: "Načítání…",
    endpointError:
      "Nepodařilo se spojit s koncovým bodem alertů v Hubu: {{error}}. Zobrazuje se poslední odpověď, pokud nějaká je.",
    serverDown: "{{url}} neodpověděl ({{error}})",
    staleFrom: " — jeho alerty níže jsou z doby ",
    alertsUnknown: " — jeho alerty nejsou známé.",
    noGrafana:
      "Není připojená žádná Grafana. Hub čte alerty z Grafany za log triage — nastavte <code>GRAFANA_DISCOVER_URL</code> nebo přidejte zdroj logů.",
    sections: {
      firing: "Spuštěné",
      firingHint: "Podmínka platí právě teď a Grafana už upozornila.",
      pending: "Čekající",
      pendingHint: "Podmínka platí, ale zatím ne tak dlouho, jak pravidlo čeká před spuštěním.",
      error: "Rozbitá pravidla",
      errorHint: "Grafana je nedokázala vyhodnotit — dokud se neopraví, o ničem nevarují.",
    },
    tiles: {
      firing: "Spuštěné",
      pending: "Čekající",
      broken: "Rozbitá pravidla",
      watched: "Sledovaná pravidla",
    },
    firingHero_one: "Spuštěn {{count}} alert",
    firingHero_other: "Spuštěno alertů: {{count}}",
    firingHero_few: "Spuštěny {{count}} alerty",
    criticalCount: "kritických: {{count}} · ",
    allClear: "Vše v pořádku",
    nothingFiring: "Nic není spuštěné napříč pravidly: {{count}}.",
    since: "od ",
    ruleInGrafana: "Pravidlo v Grafaně",
    fixInHub: "Opravit v Hubu",
    dashboard: "Dashboard",
    project: {
      heading: "Alerty projektu",
      choose: "Vyberte projekt",
      loading: "Načítání…",
      settings: "Otevřít nastavení projektu",
      folder: "Složka Grafany: {{folder}}",
      fromUid: "přiřazená uidem v nastavení",
      byName: "nalezená podle názvu",
    },
    allRules: "Všechna pravidla ({{count}})",
    targets: "cílů: {{count}}",
    banner: {
      firing_one: "Spuštěn {{count}} alert",
      firing_other: "Spuštěno alertů: {{count}}",
      firing_few: "Spuštěny {{count}} alerty",
      show: "Zobrazit →",
    },
  },
};
